export enum ProductCode {
    EcaPap = 'ECA-PAP',
    Casco = 'CASCO',
    EcaPapCasco = 'ECA-PAP+CASCO',
    Travel = 'TRAVEL',
    Life = 'LIFE',
    PersonalAccidents = 'PA',
    Home = 'HOME',
}
